/**
 * Workout Categories Configuration
 *
 * Centralized definitions for all workout types
 * Used across the app for filtering, categorization, and display
 */

export const WORKOUT_CATEGORIES = [
  {
    id: 'EMOM',
    name: 'EMOM',
    icon: '⏱️',
    color: 'indigo',
    description: 'Every Minute On the Minute',
    timerType: 'interval',
    timerDefaults: { rounds: 12, intervalSec: 60 }
  },
  {
    id: 'AMRAP',
    name: 'AMRAP',
    icon: '🔄',
    color: 'blue',
    description: 'As Many Rounds As Possible',
    timerType: 'countdown',
    timerDefaults: { capSec: 1200 }
  },
  {
    id: 'ForTime',
    name: 'For Time',
    icon: '⏰',
    color: 'green',
    description: 'Complete work ASAP',
    timerType: 'stopwatch',
    timerDefaults: { rounds: null, capSec: null }
  },
  {
    id: 'HIIT',
    name: 'HIIT',
    icon: '🔥',
    color: 'red',
    description: 'High-Intensity Intervals',
    timerType: 'interval',
    timerDefaults: { rounds: 5, workSec: 30, restSec: 30 }
  },
  {
    id: 'Strength',
    name: 'Strength',
    icon: '💪',
    color: 'purple',
    description: 'Resistance training',
    timerType: 'manual',
    timerDefaults: {}
  },
  {
    id: 'Endurance',
    name: 'Endurance',
    icon: '🏃',
    color: 'cyan',
    description: 'Cardio & stamina',
    timerType: 'stopwatch',
    timerDefaults: {}
  },
  {
    id: 'Chipper',
    name: 'Chipper',
    icon: '🪵',
    color: 'orange',
    description: 'One-time task list',
    timerType: 'stopwatch',
    timerDefaults: {}
  },
  {
    id: 'Other',
    name: 'Other',
    icon: '⭐',
    color: 'gray',
    description: 'Miscellaneous',
    timerType: 'manual',
    timerDefaults: {}
  }
];

// Helper function to get category by ID
export const getCategoryById = (id) => {
  return WORKOUT_CATEGORIES.find(cat => cat.id === id) || WORKOUT_CATEGORIES[WORKOUT_CATEGORIES.length - 1]; // Default to "Other"
};

// Helper function to get color classes for Tailwind
export const getCategoryColorClasses = (color) => {
  const colorMap = {
    indigo: 'bg-indigo-600 hover:bg-indigo-700 text-white',
    blue: 'bg-blue-600 hover:bg-blue-700 text-white',
    green: 'bg-green-600 hover:bg-green-700 text-white',
    red: 'bg-red-600 hover:bg-red-700 text-white',
    yellow: 'bg-yellow-500 hover:bg-yellow-600 text-white',
    purple: 'bg-purple-600 hover:bg-purple-700 text-white',
    cyan: 'bg-cyan-600 hover:bg-cyan-700 text-white',
    orange: 'bg-orange-600 hover:bg-orange-700 text-white',
    gray: 'bg-gray-600 hover:bg-gray-700 text-white'
  };
  return colorMap[color] || colorMap.gray;
};

// Merge workout document fields with category defaults (document wins)
export const resolveTimerSettings = (workout) => {
  const cat = getCategoryById(workout.category);
  const defaults = cat.timerDefaults || {};
  return {
    rounds:      workout.rounds      ?? defaults.rounds      ?? null,
    intervalSec: workout.intervalSec  ?? defaults.intervalSec  ?? null,
    capSec:      workout.capSec       ?? defaults.capSec       ?? null,
    workSec:     workout.workSec      ?? defaults.workSec      ?? null,
    restSec:     workout.restSec      ?? defaults.restSec      ?? null,
  };
};
